var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "top_info_container block"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("latest block")]), _c('p', {
    staticClass: "content"
  }, [_vm.block ? _c('span', [_vm._v(_vm._s(_vm.block.blockNumber))]) : _c('span', [_vm._v("N/A")])]), _c('p', {
    staticClass: "description"
  }, [_vm.block ? _c('span', [_vm._v(_vm._s(_vm._f("fromNow")(_vm.date(_vm.block.header.timestamp))))]) : _c('span', [_vm._v("N/A")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }